import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Box, Grid } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import packageJson from "../../../package.json";
import mySvg from "../../assets/images/DeviceImage.svg";
import { REACT_EMPLOYEE_LOGIN_SCREEN, REACT_FUNCTION_KEY_SCREEN } from "../../constants/ReactEndPoints";
import Header from "./Header/Header";
import LoaderGlobal from "./LoaderGlobal";
import "./styles.css";
import { removeLoggedInData } from "../../util/helperFunction";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading, selectIsModalOpen } from "../../feature/application/appSelectors";
import { setError, setModalOpen } from "../../feature/application/appSlice";
import { FloatButton, Popover } from "antd";
import { Typography, Space } from "antd";
import TranslateIcon from "@mui/icons-material/Translate";
import { changeLanguage, getCurrentLanguage, getLanguages } from "../../i18n/languageService";
import useScreenSize from "../../util/customHooks/useScreenSize";
import { useTranslation } from "react-i18next";

const INACTIVITY_TIMEOUT = 180000; // 3 minutes
const eventList = ["mousemove", "keydown", "mousedown", "touchstart", "scroll", "wheel"];

export default function MainLayout({ children }) {
  const navigate = useNavigate();
   const { t } = useTranslation();
  const isLoading = useSelector(selectIsLoading);
  const isModalOpen = useSelector(selectIsModalOpen);
  const handleRightClick = (e) => e.preventDefault();
  const handleKeyDown = (e) => e.keyCode === 123 && e.preventDefault();
  const dispatch = useDispatch();
  const { isMobile, isTablet, isLaptop, isDesktop } = useScreenSize();
  const topOffset = isDesktop ? 150 : isLaptop ? 90 : isTablet ? 80 : isMobile ? 125 : 100;
  const [showLang, setShowLang] = useState(false);
  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());

  const handleLanButton = (e) => {
    e.stopPropagation();
    setTimeout(() => {
      setShowLang(!showLang);
    }, 200);
  };

  const handleSwitchLanguage = (e, code) => {
    e.stopPropagation();
    changeLanguage(code);
    setCurrentLang(code);
    setTimeout(() => {
      setShowLang(false);
    }, 200);
  };

  useEffect(() => {
    const handleLanguageChanged = (e) => {
      setCurrentLang(e.detail);
    };
    window.addEventListener("app-language-changed", handleLanguageChanged);
    return () => window.removeEventListener("app-language-changed", handleLanguageChanged);
  }, []);

  const languageList = (
    <div
      className="language-list"
      style={{
        maxHeight: 250,
        width: 200,
        overflowY: "auto",
        padding: 8,
      }}
    >
      {getLanguages().map(({ code, native, label }) => {
      
        const isSelected = currentLang === code;

        return (
          <div
            key={code}
            tabIndex={-1}
            onMouseDown={(e) => e.preventDefault()}
            onClick={(e) => handleSwitchLanguage(e, code)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "5px 10px",
              marginBottom: "10px",
              borderRadius: "10px",
              border: "1px solid #eee",
              cursor: "pointer",
            background: isSelected
              ? "linear-gradient(114deg, #e4e7ef 0%, #F5F5F500 100%)"
              : "#fff",
              opacity: isSelected ? 0.9 : 1,
              transition: "all 0.2s ease",
              outline: "none",
            }}
          >
            <Space direction="vertical" size={0}>
              <Typography.Text
                strong
                editable={false}
                style={{
                  fontSize: 14,
                  userSelect: "none",
                  caretColor: "transparent",
                  pointerEvents: "none",
                }}
              >
                {native}
              </Typography.Text>

              <Typography.Text
                editable={false}
                style={{
                  fontSize: 12,
                  color: "#888",
                  userSelect: "none",
                  caretColor: "transparent",
                  pointerEvents: "none",
                }}
              >
                {label}
              </Typography.Text>
            </Space>

            {/* circular checkbox icon */}
            <div
              style={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                border: isSelected ? "5px solid #000" : "2px solid #ccc",
                transition: "0.2s ease",
                flexShrink: 0,
              }}
            />
          </div>
        );
      })}
    </div>
);

  const logout = () => {
    if (!window.location.href.includes("webpunch/employeeLogin")) {
      removeLoggedInData();
      dispatch(setError({}));
      dispatch(setModalOpen(false));
      navigate(REACT_EMPLOYEE_LOGIN_SCREEN);
    }
  };

  useEffect(() => {
    // Handle context menu and F12 disablement for production
    if (window.location.href.includes("webpunchprod")) {
      document.addEventListener("contextmenu", handleRightClick);
      document.addEventListener("keydown", handleKeyDown);
    }

    // Inactivity logout
    let inactivityTimeout = setTimeout(logout, INACTIVITY_TIMEOUT);
    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(logout, INACTIVITY_TIMEOUT);
    };

    eventList?.forEach((event) => document.addEventListener(event, resetInactivityTimer));

    // Cleanup
    return () => {
      clearTimeout(inactivityTimeout);

      if (window.location.href.includes("webpunchprod")) {
        document.removeEventListener("contextmenu", handleRightClick);
        document.removeEventListener("keydown", handleKeyDown);
      }

      eventList?.forEach((event) => document.removeEventListener(event, resetInactivityTimer));
    };
  }, []);

  useEffect(() => {
    const handleBackButton = (e) => {
      e.preventDefault();
      if (localStorage.getItem("isLoggedIn")) {
        navigate(REACT_FUNCTION_KEY_SCREEN, { replace: true });
      }
    };

    window.addEventListener("popstate", handleBackButton);

    return () => window.removeEventListener("popstate", handleBackButton);
  }, [navigate]);

  return (
    <Box
      sx={{
        backgroundImage: `url(${mySvg})`,
        backgroundRepeat: "no-repeat",
        height: "100%",
        width: "100%",
        margin: "auto",
      }}
    >
      {/* Logout button */}
      {!window.location.href.includes("employeeLogin") && !window.location.href.includes("terminalsetup") && (
        <Tooltip title={t("mainLayout.tooltips.logout")} placement="left">
          <LogoutOutlinedIcon
            sx={{
              color: "white",
              position: "absolute",
              top: "3.8%",
              right: "4%",
              cursor: "pointer",
            }}
            onClick={logout}
          />
        </Tooltip>
      )}

      {/* Main content */}
      <Grid
        className={isModalOpen ? "modal-blurred" : ""}
        sx={{
          width: "92%",
          height: "68%",
          backgroundColor: "#F0F7FC",
          position: "relative",
          transform: "translate(4.35%, 24%)",
        }}
      >
        <Header />
        <Grid
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "row",
            marginTop: "20px",
          }}
        >
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              display: "block",
              width: "100%",
            }}
          >
            {isLoading && <LoaderGlobal />}
            <Box display={"flex"} height="100%">
              {children}
            </Box>
          </Grid>

          <Popover
            open={showLang}
            onOpenChange={setShowLang}
            content={languageList}
            placement="rightTop"
            trigger="click"
          >
            <FloatButton
              onClick={handleLanButton}
              icon={<TranslateIcon sx={{ color: "#474A4E" }} />}
              type="default"
              style={{
                insetInlineEnd: 8,
                top: topOffset,
                position: "fixed",
              }}
            />
          </Popover>
        </Grid>
      </Grid>

      {/* Footer */}
      <Box
        component="p"
        sx={{
          color: "white",
          position: "absolute",
          bottom: "3.8%",
          right: "4%",
        }}
      >
        v{packageJson.version}
      </Box>
    </Box>
  );
}
